import { render, staticRenderFns } from "./todoBusiness.vue?vue&type=template&id=55bcf4e0&scoped=true&"
import script from "./todoBusiness.vue?vue&type=script&lang=js&"
export * from "./todoBusiness.vue?vue&type=script&lang=js&"
import style0 from "./todoBusiness.vue?vue&type=style&index=0&id=55bcf4e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bcf4e0",
  null
  
)

export default component.exports